// extracted by mini-css-extract-plugin
export var buttonContainer = "_8q-1";
export var fontSizeSelect = "_8q-3";
export var formatSelect = "_8q-2";
export var formats = "_8q-4";
export var hidden = "_8q-5";
export var icon = "_8q-6";
export var select = "_8q-0";